module.exports = __webpack_public_path__ + "static/media/forgot_password.e9df0a40.svg";